import { c as _c } from "react/compiler-runtime";
import { FormSelect } from '@systemeio/ui';
import { useClassicCoursesListAll } from 'modules/courses/courses/classic-course/hooks/use-classic-courses-list-all';
import { CourseId } from 'modules/courses/courses/types/course-interface';
import ItemSteps from 'modules/stores/store/components/item-steps';
import React, { FC } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
export interface ClassicCourseProps {
  courseId?: CourseId;
  courseSelectorError?: string;
  onChangeCourse: (courseId?: number) => void;
}
export const ClassicCourse: FC<ClassicCourseProps> = t0 => {
  const $ = _c(13);
  const {
    courseId,
    courseSelectorError,
    onChangeCourse
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    coursesData
  } = useClassicCoursesListAll();
  let t1;
  if ($[0] !== t) {
    t1 = t("dashboard.store.item.e_course.select_course.title");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("dashboard.store.item.e_course.select_course.placeholder");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== courseId || $[5] !== courseSelectorError || $[6] !== coursesData || $[7] !== onChangeCourse || $[8] !== t2) {
    t3 = <FormSelect placeholder={t2} value={courseId} data={coursesData} onChange={onChangeCourse} error={courseSelectorError} withoutCloseIcon={true} />;
    $[4] = courseId;
    $[5] = courseSelectorError;
    $[6] = coursesData;
    $[7] = onChangeCourse;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t1 || $[11] !== t3) {
    t4 = <ItemSteps steps={[{
      key: "course select",
      title: t1,
      element: t3
    }]} />;
    $[10] = t1;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};